export default "__VITE_ASSET__Ba28C7Ys__"